export default {
  paged: {
    orderBy: 'requestedAt desc',
  },
  itemDetail: {},
};
